<div class="basket-mini" *ngIf="data$ | async as data" [formGroup]="form">
  <div class="basket-mini__list" formArrayName="counters">
    <div class="basket-mini__item" *ngFor="let item of data; let i = index;" [formGroupName]="i">
      <div class="product-mini" *ngIf="item.count">
        <div class="product-mini__photo">
          <div class="product-mini__img">
            <picture class="cover-picture" *ngIf="item.size.buttonImage['src']; else itemPlug">
              <source srcset="{{ item.size.buttonImage['44x44x100.webp'] }}, {{ item.size.buttonImage['88x88x100.webp'] }} 2x">
              <img src="{{ item.size.buttonImage['src'] }}" appPictureFallback>
            </picture>
          </div>
        </div>
        <div class="product-mini__body">
          <div class="product-mini__title h3">
            {{ item.item.name }}
            <span *ngIf="item.item.itemSizes && item.item.itemSizes.length > 1">({{ item.size.sizeName }})</span>
          </div>

          <div class="product-mini__additional" *ngIf="item.modifiers">
            <ng-container *ngFor="let mod of item.modifiers">
              <span>
                <ng-container *ngIf="mod?.quantity! > 1">{{ mod?.quantity! }}x</ng-container> {{ mod?.name! }}
              </span>
            </ng-container>
          </div>

          <div class="product-mini__bottom">
            <div class="product-mini__price h3">
              <ng-container *ngIf="item.totalPrice !== 0; else zeroPrice">
                <app-price [price]="item.totalPrice"></app-price>
              </ng-container>
            </div>
            <div class="product-mini__ctrl">
              <app-counter
                formControlName="count"
                [max]="item.item.balance || infinity"
                [isDisabled]="(isBasketProcessing$ | async)?.value === 'pending'"
                (changeValue)="onChangeCount(item.itemKey, $event)"
              ></app-counter>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="basket-mini__item">
      <div class="product-mini _center">
        <div class="product-mini__photo _sm">
          <div class="product-mini__img"><i class="icomoon icomoon--cutlery"></i></div>
        </div>
        <div class="product-mini__title h3">
          <span *ngIf="(isEatinMode$ | async) === true" i18n="@@GuestCountTitle">Guest count</span>
          <span *ngIf="(isEatinMode$ | async) === false" i18n="@@CutleryTitle">Cutlery</span>
        </div>
        <div class="product-mini__ctrl">
          <app-counter
            [formControl]="guestNumberControl"
            [min]="1"
            [max]="15"
            (changeValue)="onChangeGuestCount($event)"
          ></app-counter>
        </div>
      </div>
    </div>

    <ng-container *ngIf="isDelivery$ | async">
      <div class="basket-mini__item _sticky-bottom" *ngIf="actualCostRule$ | async as actualCostRule; else emptyAddress">
        <div class="product-mini _center">
          <div class="product-mini__photo _sm">
            <div class="product-mini__img"><i class="icomoon icomoon--courier"></i></div>
          </div>
          <div class="product-mini__body">
            <div class="product-mini__title h3">
              <span i18n="@@Delivery">Delivery</span>&nbsp;
              <app-price [price]="actualCostRule.cost" *ngIf="actualCostRule.cost; else zeroPrice"></app-price>
            </div>
            <div class="product-mini__caption small" *ngIf="nextDeliveryLimit$ | async as nextDeliveryLimit">
              <ng-container *ngIf="(isBasketProcessing$ | async)?.value !== 'pending'; else textLoader">
                <span i18n="@@DeliveryPriceLimit">Before shipping costs drop</span>
                <app-price [price]="nextDeliveryLimit"></app-price>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <ng-container *ngIf="relatedProducts$ | async as relatedProducts">
    <div class="basket-mini__relevant l-wrapper-push" *ngIf="relatedProducts.length">
      <div class="basket-mini__subtitle h4" i18n="@@AddToOrder">Add to order</div>
      <div class="related-list">
        <div class="related-list__inner _grab l-wrapper-push" appDragTranslate>
          <div class="related-list__item" *ngFor="let product of relatedProducts">
            <app-related-card [product]="product"></app-related-card>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #emptyAddress>
  <div class="basket-mini__item _sticky-bottom" *ngIf="(deliveryAddress$ | async) === null">
    <div class="product-mini _center">
      <div class="product-mini__photo _sm">
        <div class="product-mini__img"><i class="icomoon icomoon--courier"></i></div>
      </div>
      <div class="product-mini__body">
        <div class="product-mini__caption small">
          <button type="button" class="link" i18n="@@DeliveryAddressEmptyMessage" (click)="onChooseAddress()">Enter your address to find out the delivery cost</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #textLoader>
  <mat-spinner color="accent" [diameter]="15"></mat-spinner>
</ng-template>

<ng-template #zeroPrice>
  <span class="h4" i18n="@@Free">Free</span>
</ng-template>

<ng-template #itemPlug>
  <i class="icomoon icomoon--dish-placeholder"></i>
</ng-template>
